<script>
import MetisMenu from "metismenujs/dist/metismenujs";



import {
  menuItems
} from "./menu";

import icons from '@/assets/icons';


/**
 * Sidenav component
 */
export default {
  components: {

  },
  data() {
    return {
      menuItems: menuItems,
      menuData: null,
      icons
    };
  },
  computed: {
    filteredMenuItems() {
      const hasPermission = (item) => !item._hidden && (!item.permission || this.$auth.hasPermissionTo(item.permission))

      const visibleItems = this.menuItems
        .filter(hasPermission)
        .map(item => {
          if (!item.subItems) return item
          return { ...item, subItems: item.subItems.filter(hasPermission) }
        })
        .filter(item => !item.subItems || item.subItems.length > 0)

      return visibleItems.filter((item, index) => {
        if (!item.isTitle) return true
        for (let i = index + 1; i < visibleItems.length; i++) {
          if (visibleItems[i].isTitle) break
          return true
        }
        return false
      })
    }
  },

  mounted: function () {

    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu("#side-menu");
    var links = document.getElementsByClassName("side-nav-link-ref");
    var matchingMenuItem = null;
    const paths = [];

    for (var i = 0; i < links.length; i++) {
      paths.push(links[i]["pathname"]);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf("/");
      const item = window.location.pathname.substr(0, strIndex).toString();
      matchingMenuItem = links[paths.indexOf(item)];
    } else {
      matchingMenuItem = links[itemIndex];
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add("mm-active");
        const parent2 = parent.parentElement.closest("ul");
        if (parent2 && parent2.id !== "side-menu") {
          parent2.classList.add("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("mm-active");
            var childAnchor = parent3.querySelector(".has-arrow");
            var childDropdown = parent3.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("mm-active");
            if (childDropdown) childDropdown.classList.add("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4 && parent4.id !== "side-menu") {
              parent4.classList.add("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5 && parent5.id !== "side-menu") {
                parent5.classList.add("mm-active");
                const childanchor = parent5.querySelector(".is-parent");
                if (childanchor && parent5.id !== "side-menu") {
                  childanchor.classList.add("mm-active");
                }
              }
            }
          }
        }
      }
    }
  },
  methods: {
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },

    toggleMenu(event) {
      event.currentTarget.nextElementSibling.classList.toggle("mm-show");
    },

    onItemHover(event, item) {
      this.$emit("itemHover", event, item);
    }
  },
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->     
    <ul id="side-menu" class="metismenu list-unstyled">
      
      <template v-for="item in filteredMenuItems">
        <li class="menu-title" v-if="item.isTitle" :key="item.id">
          {{ $t(item.label) }}
        </li>
        <li v-if="!item.isTitle && !item.isLayout" :key="item.id" @mouseenter="onItemHover($event, item)">
          <a v-if="hasItems(item)" href="javascript:void(0);" class="is-parent" :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }">
            <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
            <component v-else :is="icons[item.svg]"/>
            <span>{{ $t(item.label) }}</span>
            <span :class="`badge rounded-pill bg-${item.badge.variant} float-end`" v-if="item.badge">{{ $t(item.badge.text) }}</span>
          </a>

          <!-- if hovered, emit on hover -->
          <router-link :to="item.link" v-if="!hasItems(item)" class="side-nav-link-ref"

          >
            <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
            <!-- <img v-else-if="item.svg" :src="item.svg" alt="" /> -->
            <component v-else :is="icons[item.svg]" />
            <!-- <svg v-else-if="item.svg" :class="{'svg-icon': item.svg}">
                <use :href="item.svg">

                </use>
            </svg> -->
            <span>{{ $t(item.label) }}</span>
            <span :class="`badge rounded-pill bg-${item.badge.variant} float-end`" v-if="item.badge">{{ $t(item.badge.text) }}</span>
          </router-link>

          <ul v-if="hasItems(item)" class="sub-menu" aria-expanded="false">
            <li v-for="(subitem, index) of item.subItems" :key="index">
              <router-link :to="subitem.link" v-if="!hasItems(subitem)" class="side-nav-link-ref">{{ $t(subitem.label) }}</router-link>
              <a v-if="hasItems(subitem)" class="side-nav-link-a-ref has-arrow" href="javascript:void(0);">{{ $t(subitem.label) }}</a>
              <ul v-if="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
                <li v-for="(subSubitem, index) of subitem.subItems" :key="index">
                  <router-link :to="subSubitem.link" class="side-nav-link-ref">{{ $t(subSubitem.label) }}</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </template>
    </ul>
  </div>
  <!-- Sidebar -->
</template>

<style lang="scss">
//ul.metismenu {
//  li {
//    background-color: transparent;
//    a.is-parent {
//      background-color: transparent;
//      border-radius: 5px;
//      margin: 0;
//      padding: 10px 24px !important;
//    }
//    a.is-parent.mm-collapsed {
//      margin: 0 auto !important;
//      padding: 10px 24px;
//    }
//    a.is-parent.mm-active {
//      background-color: white;
//      padding: 10px !important;
//    }
//    ul.sub-menu {
//      background-color: #1d448a !important;
//      li {
//        margin: 0;
//        a {
//          padding-left: 42px !important;
//        }
//      }
//      li.mm-active, li.mm-collapsed {
//        background-color: transparent;
//        a {
//          color: white !important;
//        }
//        color: #BCBCBC;
//      }
//
//    }
//  }
//  li.mm-active {
//    a.is-parent {
//      padding: 10px !important;
//    }
//    a.is-parent.mm-collapsed {
//      margin: 0 auto !important;
//    }
//  }
//}
.svg-icon {
  width: 24px;
  height: 24px;
  fill: currentColor;
  display: inline-block;
  vertical-align: middle;
}
</style>
